import {AfterViewInit, Directive, DoCheck, ElementRef, Renderer2} from '@angular/core';
import {InputHighlightHelper} from "./input-highlight-helper";

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'input:not([type=checkbox]):not([type=radio])'
})
export class InputTextHighlightDirective implements AfterViewInit, DoCheck {
  private previousValue: any;
  private active = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngAfterViewInit() {
    if (this.isInsideHighlightContainer()) {
      this.active = true;
      this.updateBackground();
    }
  }

  ngDoCheck() {
    if (!this.active) {
      return;
    }
    const currentValue = this.getCurrentValue();
    if (currentValue !== this.previousValue) {
      this.previousValue = currentValue;
      this.updateBackground();
    }
  }

  private getCurrentValue(): any {
    const el = this.el.nativeElement as HTMLInputElement | HTMLSelectElement;
    return el.value || '';
  }

  private updateBackground() {
    if (!this.active) {
      return;
    }
    InputHighlightHelper.update(this.renderer, this.el.nativeElement);
  }

  private isInsideHighlightContainer(): boolean {
    let parent = this.el.nativeElement.parentElement;
    while (parent) {
      if (parent.hasAttribute('appHighlightContainer')) {
        return true;
      }
      parent = parent.parentElement;
    }
    return false;
  }

}
